import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[streetAddress]',
  standalone: false,
})
export class StreetAddressDirective {
  @Input() addressType: string | undefined;

  constructor(private elementRef: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key == '*' || event.key == '<' || event.key == '>') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    const regex = /^[^*\W][^*<>]*$/;
    const pasteData = event.clipboardData?.getData('text/plain');
    if (!regex.test(pasteData ? pasteData.toString() : '')) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) logChange(event: Event) {
    const address: string = this.elementRef.nativeElement.value;
    const regex = /^[^*\W]*$/;

    if (
      this.addressType == 'street' &&
      !regex.test(this.elementRef.nativeElement.value.charAt(0))
    ) {
      this.elementRef.nativeElement.value = address.substr(1, address.length);
    } else if (
      this.addressType == 'unit' &&
      this.elementRef.nativeElement.value.charAt(0) == ' '
    ) {
      this.elementRef.nativeElement.value = address.substr(1, address.length);
    }
  }
}
